import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'last_accessories_firmwares',
    initialState: () => {
        return {
            versions: window.PRELOAD?.last_accessories_firmwares || {},
            declines: [],
        };
    },
    reducers: {
        markDeclined: (state, action) => {
            state.declines.push(action.payload);
        },
    },
});
export const { markDeclined } = slice.actions;
export const lastAccessoriesFirmwaresReducer = slice.reducer;
